import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface LaboratoryQuestionsStatusesInterface {
    formVisible: boolean;
    formVariant: "new" | "edit";
    editId: string;
    editTitle: string;
    editAlias: string;
    editActive: boolean | null;
    deleteStatusModalVisible: boolean;
    deleteId?: string;
}

function getInitialState(): LaboratoryQuestionsStatusesInterface {
    return {
        formVisible: false,
        formVariant: "new",
        deleteStatusModalVisible: false,
        editId: "",
        editTitle: "",
        editAlias: "",
        editActive: null,
    };
}

export const LaboratoryQuestionsStatusesSlice = createSlice({
    name: "LaboratoryQuestionsStatusesSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => getInitialState(),
        updateFields: (
          state: LaboratoryQuestionsStatusesInterface,
          action: PayloadAction<Partial<LaboratoryQuestionsStatusesInterface>>
        ) => {
            Object.assign(state, action.payload);
        },

    },

});

export const {updateFields, reset} = LaboratoryQuestionsStatusesSlice.actions;

export const LaboratoryQuestionsStatusesSelectors = {
    formVisible: (state: RootState) => state.laboratoryQuestionsStatuses.formVisible,
    formVariant: (state: RootState) => state.laboratoryQuestionsStatuses.formVariant,
    editId: (state: RootState) => state.laboratoryQuestionsStatuses.editId,
    editTitle: (state: RootState) => state.laboratoryQuestionsStatuses.editTitle,
    editAlias: (state: RootState) => state.laboratoryQuestionsStatuses.editAlias,
    editActive: (state: RootState) => state.laboratoryQuestionsStatuses.editActive,
    deleteModalVisible: (state: RootState) => state.laboratoryQuestionsStatuses.deleteStatusModalVisible,
    deleteId: (state: RootState) => state.laboratoryQuestionsStatuses.deleteId,
};

export const LaboratoryQuestionsStatusesReducer = LaboratoryQuestionsStatusesSlice.reducer;
